import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axiosInstance from '../axiosInstance';
import axios from 'axios';
import { baseURL } from '../../utils/Constant';

export const setUserInfo = (userInfo) => ({
  type: 'SET_USER_INFO',
  payload: userInfo,
});


// login user
export const exchangeCodeForToken = createAsyncThunk(
  'auth/exchangeCodeForToken',
  async (code, { rejectWithValue }) => {
    try {
      const raw = axios.create();

      const tokenRes = await raw.get(`${baseURL}/auth/callback?code=${encodeURIComponent(code)}&redirectUri=${encodeURIComponent(`${window.location.origin}/callback`)}`);
      const { accessToken, refreshToken } = tokenRes.data;
      if (!accessToken) return rejectWithValue('No access token received');

      localStorage.setItem('accessToken', accessToken);
      localStorage.setItem('token', accessToken);
      if (refreshToken) localStorage.setItem('refreshToken', refreshToken);

      const userRes = await raw.get(`${baseURL}/auth/user-details`, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      const user = userRes.data || {};
      localStorage.setItem(
        'userData',
        JSON.stringify({ ...user, token: accessToken })
      );

      return { token: accessToken, refreshToken, userInfo: user };
    } catch (err) {
      return rejectWithValue('Login failed');
    }
  }
);

export const logout = createAsyncThunk(
  'auth/logout',
  async (_, { rejectWithValue }) => {
    try {
      const refreshToken = localStorage.getItem("refreshToken");
      const userData = JSON.parse(localStorage.getItem("userData") || "null");

      if (refreshToken) {
        await axiosInstance.post("/auth/logout", {
          refreshToken,
          userId: userData?.employeeId,
        });
      }
    } catch (err) {
      return rejectWithValue("Logout failed");
    }

    localStorage.clear();
    const origin = window.location.origin;
    window.location.href = `/auth/logout?redirect=${encodeURIComponent(origin)}`;
  }
);

export const authSlice = createSlice({
  name: 'auth',
  initialState:{
    isLoading: false,
    userInfo: JSON.parse(localStorage.getItem('userData') || 'null') || {},
    isAuthenticated: !!localStorage.getItem('accessToken') || !!localStorage.getItem('token'),
    apiError: false,
    errorMessage: '',
    token: localStorage.getItem('accessToken') || '',
    refreshToken: localStorage.getItem('refreshToken') || '',
  },
  reducers: {
    setUserInfo(state, action) {
      state.userInfo = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder

      .addCase(exchangeCodeForToken.fulfilled, (state, action) => {
      state.isAuthenticated = true;
      state.token = action.payload.token;
      state.refreshToken = action.payload.refreshToken;
      state.userInfo = action.payload.userInfo;
      })
      // LOGOUT
      .addCase(logout.fulfilled, (state) => {
        state.userInfo = null;
        state.isAuthenticated = false;
        state.token = '';
        state.refreshToken = '';
        state.apiError = false;
        state.errorMessage = '';
      });
  },
});

export const getUserInfo = (state) => state.auth;

export default authSlice.reducer;
